// source: http://www.opentechguides.com/how-to/article/javascript/98/detect-mobile-device.html
const testExp = new RegExp('Android|webOS|iPhone|iPad|BlackBerry|Windows Phone|Opera Mini|IEMobile|Mobile', 'i');

function isMobileOrTabletDevice() {
  return testExp.test(navigator.userAgent)
}

function isMobileDevice() {
  // 720px width based off of CSS breakpoints set in _gom-global.sass
  const width = window.innerWidth > 0 ? window.innerWidth : screen.width
  return testExp.test(navigator.userAgent) && width < 720
}

export default {
  isMobileOrTabletDevice,
  isMobileDevice
}
